import { isNotNil } from 'utils/object-util'
import { isValidNumberString } from './number-util'

const specialSymbols = ['-', '=', '@', '+', '"', '\t']

// Escapes characters that can trigger code execution in excel with a single quote
const formatToValidItems = (item: string | undefined) => {
  if (typeof item === 'string') {
    if (isValidNumberString(item)) {
      return item
    }

    if (specialSymbols.some((x) => item.startsWith(x))) {
      return `'${item}`
    }
  }

  return item
}

const quoteItem = (item: string | undefined) =>
  isNotNil(item) ? `"${item}"` : ''

export type CSVData = (string | undefined)[][]

export function csvDownload(csvData: CSVData, filename: string) {
  const csv = csvData
    .map((innerArray) =>
      innerArray.map((item) => quoteItem(formatToValidItems(item))).join(','),
    )
    .join('\n')

  const csvBlob = new Blob([csv], {
    type: 'text/csv',
  })

  const link = document.createElement('a')
  link.download = filename
  link.href = URL.createObjectURL(csvBlob)
  link.style.display = 'none'

  document.body.appendChild(link)

  link.click()

  setTimeout(() => {
    URL.revokeObjectURL(link.href)
    link.parentNode?.removeChild(link)
  }, 0)
}
